import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/strategy/')({
  component: () => <PageStub title="Strategy Hub" description="Strategic planning and execution" />,
});
